/**
 * BAMBOOVE — "NEWSLETTER POPUP": phan JS  (12/10/2026 · phieu 54)
 * ---------------------------------------------------------------------------
 * Dung <dialog> goc cua trinh duyet => co san Esc, khoa tieu diem.
 *
 * BA DIEM QUAN TRONG VE HANH VI (dung de khach KHONG thay phien):
 *   1) Khong chan ngay khi vao trang: cho `data-bb-np-cho` giay.
 *   2) Neu bat `data-bb-np-thoat="1"`: hien khi khach co Y DINH roi trang
 *      (dua chuot len mep TREN cua so) — lay lan dau tien.
 *   3) Sau khi khach dong HOAC dang ky: im lang `data-bb-np-nhac` ngay
 *      (luu moc thoi gian vao localStorage). 0 ngay = chi im trong phien nay.
 */
(function () {
  'use strict';

  var KHOA = 'bamboove-popup-lan-cuoi';
  var KHOA_PHIEN = 'bamboove-popup-phien-nay';
  /* CỜ VĨNH VIỄN: khách ĐÃ ĐĂNG KÝ (ở BẤT KỲ form nào) => KHÔNG bao giờ mời lại.
     Chỉ ghi khi form khách hàng của Shopify trả về THÀNH CÔNG — khác hẳn với
     "khách chỉ đóng popup" (trường hợp đó chỉ im `so_ngay_nhac_lai` ngày). */
  var KHOA_DA_DANG_KY = 'bamboove-popup-da-dang-ky';

  function daDangKyRoi() {
    try {
      return localStorage.getItem(KHOA_DA_DANG_KY) === '1';
    } catch (e) {
      return false;
    }
  }

  function danhDauDaDangKy() {
    try {
      localStorage.setItem(KHOA_DA_DANG_KY, '1');
    } catch (e) {
      /* chế độ riêng tư: bỏ qua */
    }
  }

  /* Trang có DẤU "đăng ký thành công" ở bất kỳ form nào không?
     · popup:      .bamboove-np__ok[role="status"]
     · dải email:  .bamboove-eb__ok[role="status"]
     · chân trang: #Email-signup__message-success-… (khối email-signup của Horizon)
     (Lỗi cũng dùng class __ok nhưng role="alert" ⇒ KHÔNG tính.) */
  function coDauThanhCong(root) {
    var p = root || document;
    if (!p.querySelector) return false;
    return !!(p.querySelector('.bamboove-np__ok[role="status"]') ||
      p.querySelector('.bamboove-eb__ok[role="status"]') ||
      p.querySelector('[id^="Email-signup__message-success-"]'));
  }

  function soNgayCho(n) {
    if (!n || n <= 0) return -1; // -1 = chi chan trong phien
    return Date.now() + n * 86400000;
  }

  function duocHien() {
    try {
      if (daDangKyRoi()) return false;
      if (sessionStorage.getItem(KHOA_PHIEN) === '1') return false;
      var het = parseInt(localStorage.getItem(KHOA) || '0', 10);
      if (het && Date.now() < het) return false;
    } catch (e) {
      /* che do rieng tu: van cho hien */
    }
    return true;
  }

  function danhDauDaXem(nhacLai) {
    try {
      sessionStorage.setItem(KHOA_PHIEN, '1');
      var het = soNgayCho(nhacLai);
      if (het > 0) localStorage.setItem(KHOA, String(het));
    } catch (e) {
      /* bo qua */
    }
  }

  function mo(dlg) {
    if (dlg.open) return;
    try {
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
    } catch (e) {
      return;
    }
    document.documentElement.style.overflow = 'hidden';
  }

  function dong(dlg, nhacLai) {
    try {
      if (typeof dlg.close === 'function') dlg.close();
      else dlg.removeAttribute('open');
    } catch (e) {
      /* bo qua */
    }
    document.documentElement.style.overflow = '';
    danhDauDaXem(nhacLai);
  }

  function chayKhoi(dlg) {
    if (dlg.getAttribute('data-bb-np-xong')) return;
    dlg.setAttribute('data-bb-np-xong', '1');

    var cho = parseInt(dlg.getAttribute('data-bb-np-cho') || '10', 10);
    if (isNaN(cho) || cho < 0) cho = 10;
    var batThoat = dlg.getAttribute('data-bb-np-thoat') === '1';
    var nhacLai = parseInt(dlg.getAttribute('data-bb-np-nhac') || '7', 10);
    if (isNaN(nhacLai) || nhacLai < 0) nhacLai = 7;

    if (!duocHien()) return;

    var hen = null;
    var daMo = false;

    function thuMo() {
      if (daMo) return;
      if (!duocHien()) return;
      daMo = true;
      mo(dlg);
    }

    if (cho > 0) hen = setTimeout(thuMo, cho * 1000);

    if (batThoat) {
      document.addEventListener('mouseout', function (e) {
        if (daMo || e.relatedTarget || e.toElement) return;
        if (e.clientY > 8) return; // chi khi chuot THOAT qua mep TREN
        if (hen) clearTimeout(hen);
        thuMo();
      });
      // thiet bi cam ung: khong co "thoat trang" => dua vao cuon sau 50%
      // May tinh van uu tien exit-intent; nguong cuon sau chi la du phong.
      var laCamUng = false;
      try {
        laCamUng = (window.matchMedia && window.matchMedia('(hover: none)').matches) ||
          (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
      } catch (e) {
        laCamUng = false;
      }
      var mocCuon = laCamUng ? 0.5 : 2.5;
      window.addEventListener('scroll', function () {
        if (daMo) return;
        if (window.scrollY > window.innerHeight * mocCuon) {
          if (hen) clearTimeout(hen);
          thuMo();
        }
      }, { passive: true });
    }

    // dong bang nut X / nut tu choi / phim Esc / bam ra ngoai
    dlg.addEventListener('click', function (e) {
      var t = e.target;
      if (t === dlg) {
        dong(dlg, nhacLai);
        return;
      }
      if (t instanceof Element && t.closest('[data-bb-np-dong]')) {
        dong(dlg, nhacLai);
      }
    });

    dlg.addEventListener('cancel', function () {
      danhDauDaXem(nhacLai);
      document.documentElement.style.overflow = '';
    });

    // dang ky xong => GHI CO VINH VIEN (khong bao gio moi lai) + tu dong dong.
    // ⚠️ 15/10/2026: neu popup CO HIEN MA (`data-bb-np-co-ma="1"`) thi dong CHAM HON (15 giay)
    //   — do duoc: dong sau 3 giay thi khach CHUA KIP doc/copy ma da mat.
    if (coDauThanhCong(dlg)) {
      danhDauDaDangKy();
      danhDauDaXem(nhacLai);
      var coMa = dlg.getAttribute('data-bb-np-co-ma') === '1';
      setTimeout(function () {
        dong(dlg, nhacLai);
      }, coMa ? 15000 : 3000);
    }
  }

  function chay(root) {
    var pham = root || document;
    if (!pham.querySelectorAll) return;
    // Khach da dang ky o BAT KY form nao (popup · dai email · chan trang) => ghi co vinh vien
    if (coDauThanhCong(pham)) danhDauDaDangKy();
    var ds = pham.querySelectorAll('[data-bb-np]');
    for (var i = 0; i < ds.length; i++) chayKhoi(ds[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      chay(document);
    });
  } else {
    chay(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    chay(e.target);
  });
})();
